import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VercelState, VercelProject } from './vercelTypes';
import { vercelAPI } from './vercelAPI';

const initialState: VercelState = {
  projects: [],
  currentProject: null,
  connected: false,
  loading: false,
  error: null,
};

const vercelSlice = createSlice({
  name: 'vercel',
  initialState,
  reducers: {
    setCurrentProject: (state, action: PayloadAction<VercelProject | null>) => {
      state.currentProject = action.payload;
    },
    clearVercelError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      vercelAPI.endpoints.getVercelStatus.matchFulfilled,
      (state, action) => {
        state.connected = action.payload.connected;
      }
    );
    
    builder.addMatcher(
      vercelAPI.endpoints.getVercelProjects.matchFulfilled,
      (state, action) => {
        state.projects = action.payload;
      }
    );
    
    builder.addMatcher(
      vercelAPI.endpoints.disconnectVercel.matchFulfilled,
      (state) => {
        state.connected = false;
        state.projects = [];
        state.currentProject = null;
      }
    );
  },
});

export const { setCurrentProject, clearVercelError } = vercelSlice.actions;
export default vercelSlice.reducer;
